import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { blogPosts } from './blogData';
import SEO, { SITE_URL } from '../SEO';
import Footer from '../Footer';
import './Blog.css';

function BlogPage() {
  return (
    <>
      <SEO
        title="AI Agents and Automation Blog for Los Angeles Businesses | UBOTIKA"
        description="Guides on AI phone agents, AI receptionists, CRM automation, and lead follow-up for Los Angeles restaurants, dental offices, law firms, and local businesses."
        path="/blog"
        image={`${SITE_URL}/og/blog.png`}
      />
      <main id="main-content" className="blog-page">
        <div className="blog-container">
        <motion.h1
          className="blog-page-title"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          UBOTIKA Blog
        </motion.h1>
        <motion.p
          className="blog-intro"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          Insights on AI automation, cost savings, and business growth for local businesses.
        </motion.p>
        <div className="blog-grid">
          {blogPosts.map((post, index) => (
            <motion.article
              key={post.slug}
              className="blog-card"
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.15 }}
            >
              <Link to={`/blog/${post.slug}`} className="blog-card-link">
                <div className="blog-card-image">
                  <img src={post.image} alt={post.title} />
                </div>
                <div className="blog-card-content">
                  <div className="blog-card-meta">
                    <span className="blog-date">{post.date}</span>
                    <span className="blog-read-time">{post.readTime}</span>
                  </div>
                  <h2>{post.title}</h2>
                  <p>{post.description}</p>
                  <div className="blog-tags">
                    {post.tags.map((tag) => (
                      <span key={tag} className="blog-tag">{tag}</span>
                    ))}
                  </div>
                </div>
              </Link>
            </motion.article>
          ))}
        </div>
        </div>
        <Footer />
      </main>
    </>
  );
}

export default BlogPage;
